import React , { Component } from 'react';
import Step from './Step';
import logo from './../img/logo-bleu.png';
import Boulier from './../img/boulier.svg';
import Rectangle from './../img/rectangle-pointu.svg';
import '@iframe-resizer/child';

class Simulateur extends Component {

	state = { 
		step : 1,
		ineligibleByAge : false,
		demandeur : {
			"role":"demandeur",
			"gir": "gir_6",
            "pensions_alimentaires_percues": 0,
            "pensions_alimentaires_versees_individu": {
            },
		},
		famille : {
			"parents":["individu"],
			"enfants":[],
			"rsa_isolement_recent":false,
		},
		menage : {
			"personne_de_reference":["individu"],
			"enfants":[],
			"conjoint":[],
			"statut_occupation_logement": "proprietaire",
			"code_postal": "75001",
			"nomVille": "Paris",
			"depcom": "75101",
			"charges_locatives": 0,
		},
		foyer_fiscal : {
			"declarants":["individu"],
			"personnes_a_charge":[]
		},
		individus: {},
	};

	/* stepsboard et steps partagent l'etape active de la simulation */
	validateStep = ( newData  , updateOnly, targetStep) => {
		this.setState((state) => {
			var newState = {};

			if ( typeof newData !== 'undefined' ) {
				Object.keys (newData ).forEach( (entity)=>{
					if ( newData[entity] === false){
						newState[entity] = undefined;
					}else{
						newState[entity] = { ...state[entity] , ...newData[entity]};
					}
				});
			}

			if (!updateOnly) {
				newState.step = targetStep || state.step + 1;
			}

			const mergedDemandeur = newState.demandeur || state.demandeur;
			if (targetStep === 4 && Number(mergedDemandeur?.age) < 65) {
				newState.ineligibleByAge = true;
			}

			return newState;
		});

		if (!updateOnly) {
			let anchor = document.getElementById('anchor');
			anchor.scrollIntoView({ behavior: 'smooth' });
		}
		this.forceUpdate();
	}
	scrollIntoView = ()=> {
		let anchor = document.getElementById('anchor');
		anchor.scrollIntoView({ behavior: 'smooth' });
	}


	previousStep = () => {
		let anchor = document.getElementById('anchor');
		anchor.scrollIntoView({ behavior: 'smooth' });
		this.setState((state) => {
  			return {step: state.step - 1};
		});
	}

	forceStep = (choice) => {
		//force step to a value
		this.setState({
            step: choice
        });
        let anchor = document.getElementById('anchor');
		anchor.scrollIntoView({ behavior: 'smooth' });

	}

    restart = () => {
    	//Reinitialiser les données a chaque retour a l'étape 1
    	this.setState({ 
			step : 1,
			ineligibleByAge : false,
			demandeur : {
				"role":"demandeur",
			},
			famille : {
				"parents":["individu"],
				"enfants":[]
			},
			menage : {
				"personne_de_reference":["individu"],
				"enfants":[],
				"conjoint":[],
				"statut_occupation_logement": "proprietaire",
				"code_postal": "75001",
				"nomVille": "Paris",
				"depcom": "75101",
				"charges_locatives": 0,
			},
			foyer_fiscal : {
				"declarants":["individu"],
				"personnes_a_charge":[]
			},
			individus: {},
			terminer: false,
		});
		// retour a l'étape 1
        this.forceStep(1); 
    }

	render () {
		return (
		<div className="Simulateur">
					<div id="anchor"> </div>
					<div className="App-header">
						<div className="rectangle-pointu" style={{backgroundImage: `url(${Rectangle})` }}><img src={Boulier} alt="boulier" className="boulier" />
						<p>
						<span>Les P'tits</span>
						<br/>
						<span>Simulateurs</span>
						</p>
						</div>
						
					</div>
			
			<div className="Steps" >
				<Step 
					step={this.state.step}
					validateStep={this.validateStep}
					individus={this.state.individus}
					conjoint={this.state.conjoint}
					demandeur={this.state.demandeur}
					famille ={this.state.famille}
					foyer_fiscal ={this.state.foyer_fiscal}
					menage={this.state.menage}
					previousStep = {this.previousStep}
					definedRessources = {this.state.definedRessources}
					restart = {this.restart}
					ineligibleByAge = {this.state.ineligibleByAge}

				/>
			</div>
			<img src={logo} alt="aide-sociale.fr" className="footer-logo" />
      	</div>
		)
	}
}

export default Simulateur;
